/**
 * Application Bootstrap
 * 
 * Entry point for the Angular application.
 * 
 * @remarks
 * - Includes polyfills for docx library (isolated to avoid global pollution)
 * - Bootstraps standalone AppComponent
 * - Uses centralized app configuration
 */

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

/**
 * Initialize polyfills for third-party libraries
 * Note: These are isolated and only loaded when needed
 */
function initializePolyfills(): void {
  // Polyfills for docx library
  // Only pollute window if absolutely necessary for library compatibility
  if (typeof window !== 'undefined') {
    import('buffer').then(({ Buffer }) => {
      (window as any).Buffer = Buffer;
      (window as any).process = { 
        env: {}, 
        nextTick: (fn: Function) => setTimeout(fn, 0) 
      };
    });
  }
}

// Initialize polyfills
initializePolyfills();

if (
  environment.production &&
  (environment.environmentName === 'production' || environment.environmentName === 'staging') &&
  !environment.auth.enableGuards
) {
  throw new Error(
    `auth.enableGuards must be true for ${environment.environmentName} builds`
  );
}

// Bootstrap application
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (!environment.production) {
      console.info(`✅ App Doctor started in ${environment.environmentName} mode`);
    }
  })
  .catch((err) => {
    // Only log bootstrap errors - all runtime errors handled by GlobalErrorHandler
    console.error('❌ Application bootstrap failed:', err);
  });
